import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {NgForOf} from "@angular/common";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";
import {VehicleService} from "../../../../core/services/vehicle.service";
import {NgbDateStruct, NgbInputDatepicker} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-procedure-vehicle',
  standalone: true,
    imports: [
        CommonSvgIconsComponent,
        NgForOf,
        ReactiveFormsModule,
        NgbInputDatepicker,
        FormsModule
    ],
  templateUrl: './procedure-vehicle.component.html',
  styleUrl: './procedure-vehicle.component.scss'
})
export class ProcedureVehicleComponent {
    @Input() sharedData: any;
    //@Output() idVehicle = new EventEmitter<number>();
    public activeStep: number = 2;
    public validate: boolean = false;
    public ProcedureVehicleForm: FormGroup;
    @Output() activeSteps = new EventEmitter<number>();


    public citiesList: any = [];

    constructor(private fb: FormBuilder, private generalService: GeneralService,private tableService: TableService,private vehicleService:VehicleService) {
        this.ProcedureVehicleForm = new FormGroup({
            vehicleId: new FormControl(null),
            insurancePolicy: new FormControl("", Validators.required),
            insuranceInitialPayment: new FormControl(""),
            insuranceMonthlyPayment: new FormControl(""),
            insuranceValidity: new FormControl<NgbDateStruct | null>(null, Validators.required),
            registeredCityId: new FormControl("", Validators.required),
            verificationFolio: new FormControl("", Validators.required),
            verificationExpirationDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
            voluntaryVerificationFolio: new FormControl("", Validators.required),
            voluntaryVerificationValidity: new FormControl<NgbDateStruct | null>(null, Validators.required),
        });
    }

    ngOnInit(): void {

        this.ProcedureVehicleForm.reset();
        this.loadList({"conditionColumn":"configurableListsField",
            "conditionValue":"Ciudad",
            "idColumn":"idconfigurableLists",
            "table":"confList",
            "valueColumn":"configurableListsCode"}, (value) => {this.citiesList = value;});

        this.findProcedure();


    }

    /*
     * Función para encontrar un trámite registrado para este Vehíuclo
     */
    findProcedure(){
        this.vehicleService.findProcedure(this.sharedData.vehicleId).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    if(res.data != 0) {
                        this.ProcedureVehicleForm.patchValue(res.data);
                        this.ProcedureVehicleForm.patchValue({
                            'insuranceValidity':this.convertToDatepickerFormat(res.data.insuranceValidity),
                            'verificationExpirationDate':this.convertToDatepickerFormat(res.data.verificationExpirationDate),
                            'voluntaryVerificationValidity':this.convertToDatepickerFormat(res.data.voluntaryVerificationValidity),
                        });
                        this.generalService.showMessage('success', res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                    }
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        )
    }

    /*
     * Función para guardar y/o editar y continuar con el siguiente form
     */
    next() {
        if (this.ProcedureVehicleForm.invalid) {
            this.validate = true;
        } else {
            this.ProcedureVehicleForm.get('vehicleId')?.setValue(this.sharedData.vehicleId);
            this.vehicleService.addVehicleProcedure(this.ProcedureVehicleForm.value).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        const number = this.activeStep + 1;
                        this.activeSteps.emit(number);
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }
    /*
     * Funcion para convertir la fecha al formato de data picker
     */
    convertToDatepickerFormat(dateString: string): { year: number, month: number, day: number } {
        const [year, month, day] = dateString.split('-').map(Number);
        return { year, month, day };
    }

    /*
     * Función dinámica para cargar listas configuarbles o catalogos
     */
    loadList(config: any, setVariable: (value: any) => void):void {
        this.tableService.loadSelectOptions(config).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    setVariable([]);
                } else {
                    setVariable(res['message']);
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                setVariable([]);
            }
        );
    }
}
